// red. TimeRail — Zeitraum-Auswahl unter dem Hero-Graph.
// Segmented-Logik OHNE Rahmen: nur die Labels + ein weicher, gleitender Thumb
// hinter dem aktiven Label (kein Track, keine Punkte, keine zieh­bare Perle).
// Antippen wählt; der Thumb gleitet (framer-motion, Spring) auf das neue Segment.
// Reihenfolge chronologisch (Serial-Position: 24h=jetzt vorne, Max=gesamt hinten).
// Große Tap-Ziele (≥44px) + leichte Haptik beim Wechsel. Farben aus T.
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { motion } from 'framer-motion';
import { EASE } from '../../styles/theme';

const SPRING = { type: 'spring', stiffness: 420, damping: 38, mass: 0.9 };

function haptic() {
  try {
    if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) {
      import('@capacitor/haptics')
        .then(({ Haptics, ImpactStyle }) => Haptics.impact({ style: ImpactStyle.Light }).catch(() => {}))
        .catch(() => {});
    }
  } catch (_) {}
}

export default function TimeRail({ value, onChange, options = [], T }) {
  const N = options.length;
  const idx = Math.max(0, options.indexOf(value));
  const ref = useRef(null);
  const [w, setW] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setW(el.clientWidth);
    update();
    let ro;
    try { ro = new ResizeObserver(update); ro.observe(el); } catch (_) {}
    window.addEventListener('resize', update);
    return () => { try { ro && ro.disconnect(); } catch (_) {} window.removeEventListener('resize', update); };
  }, []);

  const segW = N > 0 ? w / N : 0;

  const select = useCallback((opt) => {
    if (opt !== value) { haptic(); onChange(opt); }
  }, [value, onChange]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, ease: EASE }}
      style={{ padding: '14px 0 4px' }}
    >
      <div ref={ref} style={{ position: 'relative', display: 'flex', margin: '0 24px' }}>
        {/* Gleitender Thumb — weiche neutrale Fläche, KEIN Rahmen/Track. */}
        {segW > 0 && (
          <motion.div
            initial={false}
            animate={{ x: idx * segW, width: segW }}
            transition={SPRING}
            style={{
              position: 'absolute', top: 0, bottom: 0, left: 0, borderRadius: 10, zIndex: 0,
              background: T.isDark ? 'rgba(255,255,255,0.07)' : 'rgba(20,19,15,0.05)',
              pointerEvents: 'none',
            }}
          />
        )}
        {options.map((opt, i) => (
          <button
            key={opt}
            onClick={() => select(opt)}
            style={{
              position: 'relative', zIndex: 1, flex: 1, minWidth: 0,
              background: 'none', border: 'none', padding: '13px 0', cursor: 'pointer',
              fontFamily: 'inherit', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap',
              fontSize: 12.5, fontWeight: i === idx ? 700 : 600,
              color: i === idx ? T.text : T.mute,
              transition: `color 0.25s ${EASE}`, WebkitTapHighlightColor: 'transparent',
            }}
          >{opt}</button>
        ))}
      </div>
    </motion.div>
  );
}
